import { jsx } from "react/jsx-runtime";
import StyledTooltip from "../../../../../components/styled-tooltip/styled-tooltip.js";
import { useLabels } from "../../labels.provider.js";
import { CareLevelIcon } from "./care-level.styles.js";
import "@mui/material";
import "react";
import "../../assets/icons/TrustIcon.js";
const CareLevel = () => {
  const { labels } = useLabels();
  return /* @__PURE__ */ jsx(StyledTooltip, { title: labels.careLevel, placement: "top", children: /* @__PURE__ */ jsx(CareLevelIcon, {}) });
};
export {
  CareLevel
};
